<!-- 从学员列表导入 -->
<template>
    <div class="basicStyle">  
      <div class="initialLogin"  v-if="is_open">
        <div class="initialLeft">
          <img
            src="../../assets/new/tj_a2.png"
            alt=""
            style="
              vertical-align: middle;
              width: 20px;
              height: 20px;
              margin-top: -3px;
              margin-right: 10px;
            "
          /> 
          {{initialLoginText}}
        </div>
        <div class="initialRight" @click="gotIt">知道了</div>
      </div>


      <div class="querySearch">
        <div class="searchItem">
          <span>用户信息</span>
          <el-input class="w300" v-model="queryInfo.keyword" clearable size="small" placeholder=请输入学员登录账号/真实姓名/手机号></el-input>
        </div>
        <div class="searchItem">
          <span>学员标签</span>
          <!-- <el-input class="w180" v-model="queryInfo.goods" clearable size="small"></el-input> -->
          <el-select
                v-model="queryInfo.tag_id"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod1"
                :loading="loading"
                :clearable="true"
                size="mini"
              >
                <el-option
                  v-for="(item, index) in options1"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>创建时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            range-separator="至"
            @change="selectData"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>备注</span>
          <el-input class="w300" v-model="queryInfo.remark" clearable size="small" placeholder=请输入备注></el-input>
        </div>
        <div class="searchItem">
            <!-- <el-button type="primary" size="small" @click="queryTable">搜索</el-button>
            <el-button type="warning" size="small" @click="resetQuery">重置</el-button>
            <el-button type="success" size="small" @click="viewDetail">新增学员</el-button>  
            <el-button type="danger" size="small" @click="allSelected">未开通学员全部开通</el-button>  -->
            <MyButton
              value="搜索"
              size="medium"
              icon="el-icon-search"
              type="1"
              @click="queryTable"
            ></MyButton>
            <MyButton
              value="重置"
              size="medium"
              type="2"
              @click="resetQuery"
            ></MyButton>
            <MyButton
              value="新增学员"
              size="medium"
              type="3"
              @click="viewDetail()"
            ></MyButton>
            <MyButton
              v-if="group_id!=1 && role != 'nstitutionalteacher'"
              value="未开通学员全部开通"
              size="medium"
              type="3"
              @click="allSelected"
            ></MyButton>  
            <el-popover v-if="group_id!=1" placement="top-start" width="200" trigger="hover">
              <div style="text-align: left;">
                根据学员列表的筛选条件，点击后给当前列表“未开通的学员”批量开通该商品
              </div>
              <i class="el-icon--right questionIcon" slot="reference"></i>
            </el-popover>               
        </div>
      </div>
      <div class="confirmBox" v-if="choiceNum"> 
        已选择{{choiceNum}}个学员
        <span v-if="this.role!='nstitutionalteacher'">，总计开通成本费用为{{choicePrice}}元</span> 
        <el-button type="primary" size="medium" :loading="listLoading" @click="addCourse" style="margin-left: 20px;">确 定</el-button>
      </div>
      <div class="table">
        <TableComponents :columns="columns" :tableData="tableList" :tableFunction="tableFunction" @choiceGoods="choiceGoods" @delGoods="delGoods"  :tableRef='selectStudentAll' :sameItemArr='sameItemArr'>
          <!-- 学员标签管理 -->
          <template slot="studentLabel" slot-scope="{row}">
            <span v-for="(item,index) in row.tags" :key="index" class="studentLabel">{{item}}</span>
          </template>
        </TableComponents>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total">
        </el-pagination>
      </div> 
  
      <!-- 新增编辑弹窗 -->
      <el-dialog :title="dialogType" :visible.sync="addFormShow" class="formDialog" width="500px">
        <el-form :model="userInfo" :rules="rules" ref="userInfoForm" label-width="100px">
          <el-form-item label="真实姓名：" prop="realname">
            <el-input v-model="userInfo.realname" placeholder="请请输入真实姓名(2-6个汉字）" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="userInfo.mobile" placeholder="请输入手机号" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="身份证：" prop="id_card">
            <el-input v-model="userInfo.id_card" placeholder="请输入身份证" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="userInfo.remark" placeholder="请输入备注" size="mini"></el-input>
          </el-form-item>
        <el-form-item label="考试类别：" required>
          <!-- 考试类别 -->
            <el-checkbox-group v-model="appKeysType" @change="appKeysChange">
              <el-checkbox
              v-for="(item,index) in examOptions" :key="index" :label="item.key" :disabled="Boolean(item.user_is_jihuo)"
                >{{ item.value }}</el-checkbox
              >
            </el-checkbox-group>  
        </el-form-item>
          <el-form-item label="状态：">
            <el-radio-group v-model="userInfo.status" size="mini">
              <el-radio-button :label="1">启用</el-radio-button>
              <el-radio-button :label="0">禁用</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addUser('userInfoForm')" size="medium">确 定</el-button>
          <el-button @click="addFormShow = false" size="medium">取 消</el-button>
        </div>
      </el-dialog>

      
    <el-dialog :visible.sync="repeatShow" class="formDialog" width="800px">
       <div style="text-align: center;
                    font-size: 18px;
                    font-weight: bold;">{{repeatMessage}}，请确认是否新增</div>
       <div style="color: red;
                   text-align: center;
                   margin-top: 10px;"
        >（新增后姓名后面带上数字后缀，以做区别）</div>
       <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="determine(0)" size="mini">否</el-button>
        <el-button @click="determine(1)" size="mini">
           是  
        </el-button>
      </div>
    </el-dialog>



      <el-dialog
        title=""
        :visible.sync="dialogNoticeVisible"
        width="550px"
      >
        <div class="selectBox">
          <h3>开通成功</h3>
          <span>
            已成功开通商品 <span style="color:red">{{selectStudentIndex}}</span> 个
            <span v-if="this.role != 'nstitutionalteacher'">，开通成本价费用总计 <span style="color:red">{{selectStudentIndex*$route.query.price}}元</span> <span v-if="show_student_active_status == 1">（学员激活后扣除）</span> </span> 
          </span>
        </div>
      </el-dialog>
    </div>
  </template>
   
  <script>
  import commonApi from "@/api/common";
  import studentApi from '@/api/student.js'
  import goodsApi from '@/api/goods.js'
  import { deepClone } from '@/utils/index.js' 
  import TableComponents from '@/components/TableComponentsNew.vue'
  import MyButton from "@/components/MyButton.vue";
  export default {
    name:'studentSelect',
    components:{
      TableComponents,
      MyButton
    },
    data(){
      var confirmPasswordVerify = (_, value, callback) => {
        if (!value) {
          return callback(new Error("确认密码不能为空"));
        } else if (value != this.codeInfo.new_password_confirmation) {
          return callback(new Error("两次密码输入需一致"));
        } else {
          callback();
        }
      };
      return{
        options:[],
        options1:[],
        loading:false,
        queryInfo:{
          limit:10,
          page:1,
          total:0,
          // status:-1,//状态 -1全部 1启用 0禁用 
          // is_active:-1,//是否激活 -1全部 1启用 0禁用 
          keyword:"",//用户信息 支持账号真实姓名手机号
          start_time:"",//创建开始时间
          end_time:"",//创建结束时间
          tag_id:"",//标签id
          // id_card:"",//身份证号
          // tob_good_id:"",
          // createTime:[]
        },
        columns:[//列数据
          {label:"学员ID",prop:"uid"},
          {label:'学员登录账号',prop:'username'},
          {label:'真实姓名',prop:'realname'},
          {label:'手机号',prop:'mobile'},
          {label:'身份证',prop:'id_card'},
          {label:'已开通商品',prop:'courses',width:200},
          {label:'学员激活状态',prop:'active_status_txt'},
          {label:'激活时间',prop:'active_at'},
          // {label:'今日学习时长',prop:'learn_time'},
          // {label:'累计学习时长',prop:'leann_total_time'},
          {label:'学员标签',prop:'tags',width:200},
          {label:'创建人',prop:'create_user'},
          {label:'创建时间',prop:'created_at'},
          {label:'更新人',prop:'update_user'},
          {label:'更新时间',prop:'updated_at'},
          {label:'备注',prop:'remark'},
          {label:'开课状态',prop:'openStatus'},
        ],
        tableList:[],
        // 新增编辑表单数据
        addFormShow:false,
        userInfo:{
          mobile:"",
          realname:'',
          id_card:"",
          remark:"",
          status:1,
          uid:''
        },
        rules:{
          mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' },],                
          realname: [{ required: true, message: '请输入真实姓名', trigger: 'blur' },],           
        },
        tableFunction:{
            checkData:1,//是否允许勾选
            name:"dialogGoods"
        },

        // 选中的学员
        selectStudent:[],
        dialogNoticeVisible:false,
        selectStudentIndex:0,
        timeFrame:[],  
        // initialLoginShow:true,
        choicePrice:0,
        choiceNum:0,
        initialLoginText:'',
        is_open:0,
        message_id:'',
        tableRef: [],
        selectStudentAll:[],
        sameItemArr:[],
        priceNew:'',
        repeatShow:false,
        repeatMessage:"",
        postData:{},
        appKeysType:[],
        examOptions:[
        // 成考：adultscollege
        // 高职单招：senioriup
          // {value: 'adultscollege', label: '成考',actState:false},
          // {value: 'senioriup', label: '高职单招',actState:false},
        ], 
        lockState: false,
        group_id:"",
        role: "", 
        show_student_active_status: "",
        listLoading: false
      }
    },
    computed:{
      dialogType(){
        //  'this.userInfo.id',this.userInfo.uid);
        return this.userInfo.uid?'编辑':'新增'
      }
    },  
    watch:{
      selectBuyGoodsShow:{
        handler(_newVal){
          //  _newVal);
        }
      },  
      addFormShow:{
        handler(_newVal){
          if(!_newVal){
            Object.keys(this.userInfo).forEach(key =>{
              if(typeof this.userInfo[key] == 'string'){
                this.userInfo[key] = ''
              }else if((typeof this.userInfo[key] == 'number')){
                this.userInfo[key] = 1
              }
            });
            this.userInfo.uid = ''
          }
        }
      },
      timeFrame:{
        handler(_newVal){
          if(!_newVal){
            this.timeFrame = [];
          }
        },
        deep:true
      },
      tableList: {
        handler(_newVal) {
          if(_newVal){
            console.log("tableDataselectStudentAll",this.selectStudentAll,this.tableList)
            this.sameItemArr = []
            if(this.selectStudentAll&&this.selectStudentAll.length>0){
              this.selectStudentAll.forEach((itemA, index) => {
                this.tableList.forEach((itemB, index) => {
                  if (itemA.checkId == itemB.checkId) { 
                      this.sameItemArr.push(itemB); 
                  }
                });
              }); 
            }
          }
        }
      }

    },
    created(){  
      this.show_student_active_status = localStorage.getItem("show_student_active_status"); 

      this.role = this.$store.state.user.userInfo.role
      this.priceNew = this.$route.query.price 
      this.group_id = this.$route.query.group_id 
      this.getTobOpenExams();
      this.getTobTipMessageInfo()
      this.queryTable()
    },  
    methods:{
    
      appKeysChange(e){
        console.log('appKeysChange',e)
      },
      determine(e){ 
        if(e){ 
          var query = deepClone(this.postData);
          query.is_add_exist_name = e;
          studentApi.studentsAdd(query).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.queryTable()
                this.postData={}
                this.repeatShow = false;
              }else{
                this.$message.error(res.message)
              }  
          });
        }else{
          this.repeatShow = false;
          this.postData={}
        }
      }, 
      getTobTipMessageInfo(){
        const res = goodsApi.getTobTipMessageInfo({type_id:1}) 
          .then(res => { 
            if (res.code == 200) { 
              console.log('getTobTipMessageInfo',res)
              this.initialLoginText = res.data.info.content
              this.message_id = res.data.info.message_id
              this.is_open = res.data.info.is_open
            }else{
              this.$message.error(res.message)
            }
          }) 
      },
      gotIt(){
        const res = goodsApi.tipMessageColse({message_id:this.message_id}) 
          .then(res => { 
            if (res.code == 200) { 
              console.log('tipMessageColse',res) 
              this.getTobTipMessageInfo()
              this.$message({
                message: res.message,
                type: 'success'
              });
            }else{
              this.$message.error(res.message)
            }
          }) 
      },
      async allSelected() {  
        this.queryInfo.tob_good_id = this.$route.query.tobGoodId
        goodsApi.getNoPowerStudent(this.queryInfo).then((res) => {
          if (res.code == 200) { 
            var noPowerStudent = '已选择' + res.data.student_count + '个学员，总计开通成本费为' + res.data.cb_price_total + '元' 

            // var noPowerStudent = '' 
            // if(this.role == 'nstitutionalteacher'){
            //   noPowerStudent = '已选择' + res.data.student_count + '个学员'
            // } else {
            //   noPowerStudent = '<div style="color:#333">已成功开通商品<text style="color:red">' + res.data.student_count + '</text>个，开通成本价费用总计<text style="color:red">' + res.data.cb_price_total + '元</text>（学员激活后扣除）</div>'
            // } 

            this.$confirm(noPowerStudent, '批量开通提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {   
              if (!this.lockState) {
                this.lockState = true;
                var query = deepClone(this.queryInfo);
                if(this.$route.query.courseId){ 
                  query.tob_user_id = ''
                  query.course_id = this.$route.query.courseId
                  query.is_all_user = '1'
                  // 学员添加课程
                  const res = goodsApi.addCoursePower(query)
                  .then(res => { 
                    if (res.code == 200) { 
                      this.lockState = false;
                      var returnData = '' 
                      if(this.role == 'nstitutionalteacher'){
                        returnData = '<div style="color:#333">已成功开通商品<text style="color:red">' + res.data.student_count + '</text>个'
                      } else {
                        returnData = '<div style="color:#333">已成功开通商品<text style="color:red">' + res.data.student_count + '</text>个，开通成本价费用总计<text style="color:red">' + res.data.cb_price_total + '元</text>（学员激活后扣除）</div>'
                      }
  
                      this.$alert(returnData, '开通成功', {
                        dangerouslyUseHTMLString: true
                      });  
                      this.queryTable() 
                    }else{ 
                      this.lockState = false;
                      this.$message.error(res.message)
                    }
                  }) 
                }else if(this.$route.query.packageId){ 
                  query.tob_user_id = ''
                  query.package_id = this.$route.query.packageId
                  query.is_all_user = '1' 
                  // 学员添加套餐
                  const res = goodsApi.addPackagePower(query) 
                  .then(res => { 
                    if (res.code == 200) { 
                      this.lockState = false;  
                      var returnData = '' 
                      if(this.role == 'nstitutionalteacher'){
                        returnData = '<div style="color:#333">已成功开通商品<text style="color:red">' + res.data.student_count + '</text>个'
                      } else {
                        returnData = '<div style="color:#333">已成功开通商品<text style="color:red">' + res.data.student_count + '</text>个，开通成本价费用总计<text style="color:red">' + res.data.cb_price_total + '元</text>（学员激活后扣除）</div>'
                      } 
                      this.$alert(returnData, '开通成功', {
                        dangerouslyUseHTMLString: true
                      });  
                      this.queryTable() 
                    }else{ 
                      this.lockState = false;
                      this.$message.error(res.message)
                    }
                  }) 
                } else {
                  query.tob_user_id = ''
                  query.member_id = this.$route.query.memberId
                  query.is_all_user = '1'
                  // 学员添加会员
                  const res = goodsApi.addMemberPower(query)
                  .then(res => { 
                    if (res.code == 200) { 
                      this.lockState = false; 
                      var returnData = '' 
                      if(this.role == 'nstitutionalteacher'){
                        returnData = '<div style="color:#333">已成功开通商品<text style="color:red">' + res.data.student_count + '</text>个'
                      } else {
                        returnData = '<div style="color:#333">已成功开通商品<text style="color:red">' + res.data.student_count + '</text>个，开通成本价费用总计<text style="color:red">' + res.data.cb_price_total + '元</text>（学员激活后扣除）</div>'
                      }
                      
                      this.$alert(returnData, '开通成功', {
                        dangerouslyUseHTMLString: true
                      });  
                      this.queryTable() 
                    }else{ 
                      this.lockState = false;
                      this.$message.error(res.message)
                    }
                  }) 
                }
              } 
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });  
          }else{ 
            this.$message.error(res.message)
          }
        }) 
      },
      remoteMethod(query) {
        if (query !== "") {
          this.loading = true;
          setTimeout(async () => {
            this.loading = false;
            const companyName = query;
            const res = await studentApi.tobGoodList({ good_name: companyName });
            this.options = res.data;
          }, 200);
        } else {
          this.options = [];
        }
      },
      remoteMethod1(query) {
        if (query !== "") {
          this.loading = true;
          setTimeout(async () => {
            this.loading = false;
            const companyName = query;
            const res = await commonApi.getTobSearchTags({ name: companyName,common_tag_type:2 });
            this.options1 = res.data.data;
          }, 200);
        } else {
          this.options = [];
        }
      },
    async getTobOpenExams() {
      const res = await goodsApi.getTobOpenExams(this.queryInfo);
      if (res.code == 200) {
        this.examOptionsArr = res.data.exam_list
        console.log("getTobOpenExams---", this.examOptionsArr);
      }
    },
      // 列表数据
      async queryTable(_type){
        if(_type){
          this.queryInfo.page = 1
        }
        this.queryInfo.tob_good_id = this.$route.query.tobGoodId
        const res = await studentApi.studentsList(this.queryInfo)
        if(res.code == 200){
          this.queryInfo.total = res.data.total
          this.tableList = res.data.data
          this.selectList = []
          this.tableList.forEach((item,index) => { 
            item.checkId = item.uid
            item.openStatus = item.user_power?"已开通":"未开通"  
          });
          //  this.tableList);
        }else{
          this.$message.error(res.message)
        }
      },
      // 打开弹窗
      viewDetail(row){
        if(row&&row.uid){
          this.appKeysType = []
          if(row.group_app_list&&row.group_app_list.length>0){
            row.group_app_list.forEach(item => {
              if(item.user_is_kaitong){
                this.appKeysType.push(item.app_type)
              }
            })
          }
          this.examOptions = []
          row.group_app_list.forEach(itemB => {
            this.examOptions.push({
              key:itemB.app_type,
              value:itemB.app_type_name,
              user_is_jihuo:itemB.user_is_jihuo,
              user_is_kaitong:itemB.user_is_kaitong,
            })
          })

        }else{ 
          this.appKeysType = []
          this.examOptions = this.examOptionsArr
          this.examOptions.forEach(itemA => {
            itemA.user_is_kaitong = 0;
            this.appKeysType.push(itemA.key)
          })
        }
        console.log('this.examOptions',this.examOptions)
        
 

        if(row&&row.uid){
          Object.assign(this.userInfo,row)
        }
        //  this.userInfo);
        this.addFormShow = true
      },
      // 添加｜｜修改数据
      addUser(formName){
        if(this.appKeysType.length==0){
        this.$message({
          message: "考试类别必须选一个！",
          type: "error"
        });
        return
      }
      this.userInfo.app_keys = this.appKeysType.toString()  
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            let res
            if(this.userInfo.uid){
              res = await studentApi.studentsEdit(this.userInfo)
            }else{
              res = await studentApi.studentsAdd(this.userInfo)
            }
            if(res.code == 200){
              this.$message.success(`${this.dialogType}成功`)
              this.queryTable()
              this.addFormShow = false
            }else{
                    if(res.data.is_group_exist_realname){
                      this.postData = deepClone(this.userInfo);
                      this.repeatShow = true
                      this.addFormShow = false
                      this.repeatMessage = res.message
                    } else{ 
                      this.$message.error(res.message)
                    }
                    this.antiShaking = true 
            }
          } else {
            //  'error submit!!');
            return false;
          }
        });
      },
  
  
      // 分页
      handleSizeChange(e){
        //  e);
        this.queryInfo.limit = e
        this.queryTable()
      },
      handleCurrentChange(e){
        this.queryInfo.page = e
        this.queryTable()
      },
      resetQuery(){
        this.timeFrame = []
        this.queryInfo = {
          limit:10,
          page:1,
          total:0,
          status:-1,//状态 -1全部 1启用 0禁用 
          is_active:-1,//是否激活 -1全部 1启用 0禁用 
          keyword:"",//用户信息 支持账号真实姓名手机号
          start_time:"",//创建开始时间
          end_time:"",//创建结束时间
          tag_id:"",//标签id
          id_card:"",//身份证号
          // createTime:[]
        }
        this.queryTable()
      },
      // 选择日期
      selectData(e){
        //  e);
        if(e){
          this.queryInfo.start_time = e[0]
          this.queryInfo.end_time = e[1]
        }else{
          this.queryInfo.start_time = ''
          this.queryInfo.end_time = ''
        }
        
      },
      unique(arr) {
        // return Array.from(new Set(arr));
        for (var i = 0; i < arr.length; i++) {
          for (var j = 0; j < arr.length; j++) {
            if (arr[i].uid == arr[j].uid && i != j) {
              // 将后面重复的数删掉
              arr.splice(j, 1);
            }
          }
        }
        return arr;
      },
      delGoods(e){ 
        console.log("delGoods--1", e);
        if(e&&e.length>0){
          e.forEach((itemA) => {
            this.selectStudentAll .forEach((itemB,index) => {
              if(itemA.uid==itemB.uid){
                this.selectStudentAll.splice(index, 1)
              }
            }) 
          })
        } 
        this.unique(this.selectStudentAll) 
        this.selectStudent = this.selectStudentAll,
        this.choiceNum = this.selectStudentAll.length,
         
        this.choicePrice = this.choiceNum*(this.priceNew*1000)/1000

        console.log("delGoods--2", this.selectStudentAll);
      },
      choiceGoods(e){
        console.log("choiceGoods", e); 
        if(e&&e.length>0){
          e.forEach((item,index) => { 
            this.selectStudentAll.push(item);
          })
        }
        this.unique(this.selectStudentAll) 
        this.selectStudent = this.selectStudentAll,
        this.choiceNum = this.selectStudentAll.length,
        this.choicePrice = this.choiceNum*(this.priceNew*1000)/1000
      },
      async addCourse(){
        this.selectStudentIndex = 0;
        if(!this.selectStudent.length){
          this.$message.error('请选择需要开通的学员');
          return
        }
        let _obj = this.selectStudent.map(item=>{
            return item.uid
        }) 
        
        this.listLoading = true;
        if(this.$route.query.packageId){ 
          const res =await goodsApi.addPackagePower({ 
            tob_good_id:this.$route.query.tobGoodId,
            tob_user_id:_obj.join(","),
            package_id:this.$route.query.packageId
          })
          if(res.code == 200){
            this.dialogNoticeVisible = true
            this.queryTable()
            this.selectStudentIndex = this.selectStudent.length
            this.selectStudent = [] 
            this.choiceNum = 0
            this.choicePrice = 0
            this.selectStudentAll = []  
          }else{
            this.$message.error(res.message)
          }
        }else if(this.$route.query.memberId){
          const res =await goodsApi.addMemberPower({
            tob_good_id:this.$route.query.tobGoodId,
            tob_user_id:_obj.join(","),
            member_id:this.$route.query.memberId
          })
          if(res.code == 200){
              this.dialogNoticeVisible = true
              this.queryTable()
              this.selectStudentIndex = this.selectStudent.length
              this.selectStudent = []
              this.choiceNum = 0
              this.choicePrice = 0
              this.selectStudentAll = [] 
              this.listLoading = false
          }else{
            this.listLoading = false
            this.$message.error(res.message)
          }
        }else{
          const res =await goodsApi.addCoursePower({
            tob_good_id:this.$route.query.tobGoodId,
            tob_user_id:_obj.join(","),
            course_id:this.$route.query.courseId
          })
          if(res.code == 200){
            this.dialogNoticeVisible = true
            this.queryTable()
            this.selectStudentIndex = this.selectStudent.length 
            this.selectStudent = []
            this.choiceNum = 0
            this.choicePrice = 0
            this.selectStudentAll = [] 
          }else{
            this.$message.error(res.message)
          }
        } 
      },
      cancel(){
        this.$router.go(-1)
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .basicStyle{
    span{
      display: inline-block;
    }
    .querySearch{
      .searchItem{
        display: inline-block;
        margin: 0 20px 20px 0 ;
        span{
          margin-right: 10px;
          font-size: 14px;
        }
        /deep/ .el-input{
          width: 230px;
        }
      }
      /deep/ .el-button--primary{
        margin-left: 50px;
      }
    }
    .addInfo{
      margin: 20px 0;
    }
  
    // 表格数据
    .table{
      min-height: calc(100vh - 330px);
      .studentLabel{
        display: inline-block;
        padding: 5px 10px;
        background-color: #409EFF;
        color: #fff;
        border-radius: 4px;
        margin: 0 5px 5px 0;
      }
    }
    .operationItem{
      display: inline-block;
      margin: 0 5px;
      cursor: pointer;
      color: rgb(87, 87, 239);
    }
  
    /deep/ .formDialog{
      .el-select .el-input{
        width: 180px;
      }
      .el-input{
        width: 250px;
      }
      .dialog-footer{
        text-align: center;
      }
    }
  }
  
  // 添加标签样式
  /deep/ .editLabelClass{
    display: flex;
    align-items: flex-start;
    .p1{
      margin-right: 20px;
      width: 70px;
      line-height: 30px;
    }
    .p2{
      flex: 1;
    }
    .el-tag{
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .searchItem{
      .el-input{
        width: 200px;
        margin: 0 20px;
      }
    }
  }
  .editLabelClass+.editLabelClass{
    margin-top: 20px;
  }
  
  .initialLogin {
    background: #ffebeb;
    border-radius: 8px 8px 8px 8px;
    line-height: 45px;
    padding: 0 20px 0 16px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    align-items: center;
    .initialLeft {
      color: #191b27;
      font-size: 15px;
      font-weight: 500;
    }
    .initialRight {
      height: 32px;
      width: 72px;
      background: linear-gradient(234deg, #ff6157 0%, #ff418a 100%);
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      line-height: 32px;
      text-align: center;
      font-size: 13px;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .confirmBox{
    padding: 10px 20px;
    background: #fff;
  }
  .selectBox{
    text-align:center;
    padding: 50px 0 100px 0;
    h3{
      margin-bottom: 20px;
    }
  }
  
.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-left: 10px;
}
.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}

  </style>